<!-- 使用示例 -->

<!-- 
	<MyDialog :dialogForm="dialogForm" />
-->

<template>
	<van-dialog v-model="dialogForm.show" class="dialogs" :show-confirm-button="false">
		<div class="header">
			<span class="title">
				{{ dialogForm.title }}
			</span>
			<img class="icon" src="@/assets/images/product/icon_close.png" @click="dialogForm.show = false" />
		</div>
		<div class="tips" v-html="dialogForm.contentTips">
		</div>
		<div class="body">
			{{ dialogForm.contentText }}
		</div>
		<div class="footer" v-if="dialogForm.btnCancelText || dialogForm.btnConfirmText">
			<div v-if="dialogForm.btnCancelText" class="btn cancelorder" @click="dialogForm.cancelCallback">
				{{ dialogForm.btnCancelText }}
			</div>
			<div v-if="dialogForm.btnConfirmText" class="btn confirmorder" @click="dialogForm.confirmCallback">
				{{ dialogForm.btnConfirmText }}
			</div>
		</div>
	</van-dialog>
</template>

<script>
export default {
	name: 'MyDialog',
	components: {},
	props: {
		dialogForm: {
			type: Object,
			default: () => {
				return {
					show: false,
					title: '提示',
					contentText: '',
					contentTips: '',
					btnCancelText: '',
					btnConfirmText: '',
					cancelCallback: () => { },
					confirmCallback: () => { }
				}
			}
		}
	},
	data() {
		return {}
	},

	methods: {}
}
</script>

<style lang="less" scoped>
.dialogs {
	width: 304px;
	background: linear-gradient(180deg, #E3FFF2 0%, #FBFCFE 35%, #FFFFFF 100%);
	border-radius: 22px;
	padding: 12px 0 20px;

	.header {
		padding: 0 15px;
		height: 18px;
		text-align: center;
		display: flex;
		flex-direction: row;
		flex-wrap: nowrap;
		align-content: center;
		justify-content: center;
		align-items: center;
		position: relative;

		.title {
			height: 18px;
			font-family: PingFangSC, PingFang SC;
			font-weight: 500;
			font-size: 15px;
			color: #333333;
			line-height: 18px;
		}

		.icon {
			width: 12px;
			height: 12px;
			position: absolute;
			top: 3px;
			right: 15px;
		}
	}

	.tips {
		margin: 20px 20px 30px;
		width: 260px;
		font-family: PingFangSC, PingFang SC;
		font-weight: 400;
		font-size: 11px;
		color: #666666;
		line-height: 14px;
		text-align: left;
		font-style: normal;
	}

	.body {
		margin: 20px;
		width: 260px;
		font-family: PingFangSC, PingFang SC;
		font-weight: 400;
		font-size: 14px;
		color: #333333;
		line-height: 20px;
		text-align: center;
		font-style: normal;
	}

	.footer {
		box-sizing: border-box;
		margin-top: 18px;
		display: flex;
		flex-direction: row;
		flex-wrap: nowrap;
		justify-content: space-around;
		align-items: flex-end;
		padding: 0 10px;

		// align-items: flex-start;
		.cancelorder {
			margin: 0 10px;
			flex: 1;
			width: 122px;
			height: 40px;
			border-radius: 10px;
			border: 1px solid #CCCCCC;
			font-family: PingFangSC, PingFang SC;
			font-weight: 400;
			font-size: 15px;
			color: #333333;
			line-height: 40px;
			text-align: center;
		}

		.confirmorder {
			margin: 0 10px;
			flex: 1;
			height: 40px;
			line-height: 40px;
			text-align: center;
			background: #00754A;
			border-radius: 10px;
			font-family: PingFangSC, PingFang SC;
			font-weight: 500;
			font-size: 15px;
			color: #FFFFFF;
		}
	}
}
</style>



// WEBPACK FOOTER //
// src/components/MyDialog.vue